export const OrderByOptions: Array<ICheckbox> = [
  {value: 'lastest', name: 'جدید‌ترین'},
  {value: 'cheapest', name: 'ارزان‌ترین'},
  {value: 'most_expensive', name: 'گران‌ترین'},
  {value: 'nearest', name: 'نزدیک‌ترین'},
  {value: 'high_quality', name: 'بالاترین کیفیت'},
];
export const OrderByOptionsWithoutPrepayment: Array<ICheckbox> = [
  {value: 'lastest', name: 'جدید‌ترین'},
  {value: 'cheapest', name: 'ارزان‌ترین'},
  {value: 'most_expensive', name: 'گران‌ترین'},
  {value: 'nearest', name: 'نزدیک‌ترین'},
];
